module.exports = __webpack_public_path__ + "static/media/frog(19).ff51f683.PNG";